<template>
  <v-card v-if="item">
    <v-container>
      <v-layout align-center justify-space-between wrap class="mb-2">
        <h2 class="title">{{ item.title }}</h2>
        <navigation :id="item.id" />
      </v-layout>
      <p class="body-1">Hinweis: {{ item.text }}</p>
      <notice-date @save="save"></notice-date>
      <router-link
        :to="{ name: 'page', params: { id: low.target } }"
        class="v-btn v-btn--depressed v-btn--small theme--light primary css-extend"
        :id="`p${item.id}-t${low.target}`"
      >
        Weiss nicht
      </router-link>
    </v-container>
  </v-card>
</template>

<style>
.css-extend {
  margin-bottom: 300px;
}
</style>

<script>
import NoticeDate from "./NoticeDate.vue";
import Navigation from "./Navigation.vue";

export default {
  props: ["item"],
  components: {
    NoticeDate,
    Navigation
  },
  computed: {
    low() {
      return this.item.options.find(o => o.label === "lt3weeks");
    },
    high() {
      return this.item.options.find(o => o.label === "gte3weeks");
    }
  },
  methods: {
    save(noticegt3weeks) {
      const { target } = noticegt3weeks ? this.high : this.low;
      this.$router.push({ name: "page", params: { id: target } });
    }
  }
};
</script>
